import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { getProviderLabel } from 'pages/Settings/integrationSettingLabels';
import './IntegrationProvider.scss';

const getInitials = (label) =>
  label
    .split(' ')
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();

const IntegrationProvider = ({ provider }) => {
  const i18n = useContext(i18nContext);
  const label = getProviderLabel(i18n, provider);

  return (
    <span className={'integration-provider'}>
      <span className={'integration-provider-avatar'}>{getInitials(label)}</span>
      <span className={'integration-provider-name'}>{label}</span>
      <code className={'integration-code'}>{provider}</code>
    </span>
  );
};

IntegrationProvider.propTypes = {
  provider: PropTypes.string.isRequired
};

export default IntegrationProvider;
